module.exports = __webpack_public_path__ + "img/map.c952df31.svg";